/**
 * Parses a CSV string into an array of objects.
 * @param csvText - The CSV string to parse.
 * @returns An array of objects, where each object represents a row in the CSV file.
 * The keys of the object are the headers of the CSV file, and the values are the values of the row.
 * If a cell is empty, the value will be an empty string.
 */
export const parseCSV = (csvText: string): Array<Record<string, string>> => {
  const lines = csvText.split('\n').filter(line => line.trim());
  if (lines.length === 0) return [];

  const headers = lines[0]
    .split(',')
    .map(header => header.trim().replace(/"/g, ''));
  const data: Array<Record<string, string>> = [];

  for (let i = 1; i < lines.length; i++) {
    const values = lines[i]
      .split(',')
      .map(value => value.trim().replace(/"/g, ''));
    const row: Record<string, string> = {};

    headers.forEach((header, index) => {
      row[header] = values[index] || '';
    });

    data.push(row);
  }

  return data;
};
